import { EventTypeBackend, EventUnion } from '../../../types/events.types';
import { SharePlanType } from '../../../types/pool-plans.types';

const exerciseBackedEventTypes: EventTypeBackend[] = [
  EventTypeBackend.APPROVAL,
  EventTypeBackend.EXERCISE,
  EventTypeBackend.EXPIRE,
  EventTypeBackend.PAYOUT,
];

const eventsModuleExerciseEditReadyPlanTypes = new Set<SharePlanType>([
  SharePlanType.BSPCE,
  SharePlanType.STOCK_OPTIONS,
]);

export const isExerciseBackedEventType = (eventType: EventTypeBackend): boolean =>
  exerciseBackedEventTypes.includes(eventType);

export const isEventsModuleExerciseEditEnabled = (event: EventUnion): boolean => {
  if (!isExerciseBackedEventType(event.type)) return true;
  const items = 'exercise' in event && event.exercise?.items?.length ? event.exercise.items : [];
  if (items.length === 0) return false;
  return items.every((item) =>
    eventsModuleExerciseEditReadyPlanTypes.has(item.vestingTask.grantItem.plan.type),
  );
};
